import React, { FC, useContext, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";

import {
  Button,
  Card,
  List,
  ListItem,
  ListItemPrefix,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Typography,
} from "@material-tailwind/react";
import { AuthContext } from "context/appContext";
import { getMenuItems } from "data/ClientMenu";
import { ProfilClient } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import useIsMobile from "hooks/isMobile";
import { getUserStats } from "redux/features/Admin/Stripe/stripeSlice";

export interface CommonLayoutProps {
  children?: React.ReactNode;
  clientName?: string;
  id?: string;
}

const CommonLayout: FC<CommonLayoutProps> = ({ children }) => {
  const authContext = useContext(AuthContext);
  const customer_id = authContext?.user?.customer_id;
  const is_customer = authContext?.user?.isCustomer;
  let profile = authContext.user?.profil as ProfilClient;

  const stats = useAppSelector((state) => state?.stripe?.ownerStats);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      getUserStats({
        userId: profile?.id,
        account_id: profile?.account_id || "",
        status: profile?.validation || "",
      })
    );
  }, []);

  const location = useLocation();
  const isActive = location.pathname;
  const isActivePath = (path: string) => location.pathname === path;

  const menuItems = getMenuItems(profile, stats, isActive, customer_id || "", is_customer);
  const isMobile = useIsMobile();
  return (
    <div className="flex flex-col lg:flex-row">
      {isMobile ? (
        <Menu animate={{ mount: { y: 0 }, unmount: { y: 25 } }}>
          <MenuHandler>
            <Button className="dark:text-dark">
              <div>
                <i className="mt-1 text-xl las la-bars"></i>
              </div>
              &nbsp; Dashboard
            </Button>
          </MenuHandler>
          <MenuList>
            {menuItems.map(
              (item) =>
                item.condition && (
                  <MenuItem key={item.to}>
                    <Link to={item.to} className="flex items-center">
                      {item.icon}
                      {item.label}
                    </Link>
                  </MenuItem>
                )
            )}
          </MenuList>
        </Menu>
      ) : (
        <div className="p-6 border-r lg:w-1/4 border-neutral-200 dark:border-neutral-700">
          <Card className="h-full lg:h-[calc(100vh-2rem)] w-full max-w-[20rem] lg:max-w-none p-4 shadow-xl shadow-blue-gray-900/5 dark:bg-gray-800 dark:text-white">
            <div className="p-4 mb-2">
              <Typography variant="h5" color="blue-gray">
                Bienvenue
              </Typography>
            </div>
            <List>
              {menuItems.map((item) => {
                if (item.condition) {
                  return (
                    <ListItem
                      key={item.to}
                      className={
                        item.className ? item.className : isActivePath(item.to) ? "font-bold text-eventToBee" : ""
                      }
                    >
                      <ListItemPrefix>{item.icon}</ListItemPrefix>
                      <Link to={item.to}>{item.label}</Link>
                    </ListItem>
                  );
                }
                return null;
              })}
            </List>
          </Card>
        </div>
      )}

      <div className="w-full pb-24 ml-5 pt-14 sm:pt-20 lg:pb-32">{children}</div>
    </div>
  );
};

export default CommonLayout;
